import Flickity from "flickity";

const sliders = document.querySelectorAll("[data-testimonial-slider]");
if (sliders.length) {
	for (const slider of sliders) {
		const flickity = new Flickity(slider, {
			// options
			contain: true,
			pageDots: true,
			freeScroll: true,
			wrapAround: true,
		});
	}
}
